import { Children, useRef, type HTMLAttributes, type ReactElement, forwardRef } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';
import { List } from '@mui/material';

export const VirtualizedListbox = forwardRef<HTMLDivElement, HTMLAttributes<HTMLElement>>(
  function VirtualizedListbox({ children, ...props }, ref) {
    const items = Children.toArray(children) as ReactElement[];
    const scrollRef = useRef<HTMLDivElement>(null);

    const virtualizer = useVirtualizer({
      count: items.length,
      estimateSize: () => 56,
      getScrollElement: () => scrollRef.current,
    });

    return (
      <div
        ref={ref}
        style={{
          height: `400px`,
          overflow: 'auto', // Make it scroll!
        }}
      >
        <List
          {...props}
          ref={scrollRef}
          component="div"
          sx={{
            height: virtualizer.getTotalSize(),
            width: '100%',
            position: 'relative',
          }}
        >
          {virtualizer.getVirtualItems().map((item) => (
            <div
              key={item.key}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: `${item.size}px`,
                transform: `translateY(${item.start}px)`,
              }}
            >
              {items[item.index]}
            </div>
          ))}
        </List>
      </div>
    );
  },
);
